module.exports = __webpack_public_path__ + "static/img/10.82be92b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/10.png
// module id = wa3f
// module chunks = 0